import { render } from "./GoogleSigninBtn.vue?vue&type=template&id=53e11222&scoped=true"
import script from "./GoogleSigninBtn.vue?vue&type=script&lang=js"
export * from "./GoogleSigninBtn.vue?vue&type=script&lang=js"

import "./GoogleSigninBtn.vue?vue&type=style&index=0&id=53e11222&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53e11222"]])

export default __exports__